import React, { useContext, useState } from "react";

import { store } from "./lib/store";
import SpinLoader from "./library/components/spinner/spinner";

import { Table } from "antd";
import "antd/dist/antd.css";
import Axios from "axios";
import "./App.css";
import { getAjaxUrl } from "./lib/helpers";
import SearchPopulation from "./library/components/SearchPopulation/SearchPopulation";

function PopulationReport() {
  const { state } = useContext(store);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);

  const headers = [
    {
      title: "Player",
      dataIndex: "name",
      width: 150,
      sorter: (a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0),
    },
    { title: "Year", dataIndex: "year", width: 100 },
    { title: "Company", dataIndex: "company", width: 100 },
    {
      title: "Set",
      dataIndex: "set",
      width: 150,
      sorter: (a, b) => (a.set < b.set ? -1 : a.set > b.set ? 1 : 0),
    },
    {
      title: "Subset",
      dataIndex: "subset",
      width: 150,
      sorter: (a, b) =>
        a.subset < b.subset ? -1 : a.subset > b.subset ? 1 : 0,
    },
    {
      title: "Card#",
      dataIndex: "card_no",
      width: 100,
      sorter: (a, b) => a.card_no - b.card_no,
    },
    {
      title: "10.0F",
      dataIndex: "10.0F",
      sorter: (a, b) => a["10.0F"] - b["10.0F"],
      width: 75,
    },
    {
      title: "10.00",
      dataIndex: "10.0",
      sorter: (a, b) => a["10.00"] - b["10.00"],
      width: 75,
    },
    {
      title: "9.50",
      dataIndex: "9.5",
      sorter: (a, b) => a["9.50"] - b["9.50"],
      width: 75,
    },
    {
      title: "9.00",
      dataIndex: "9.0",
      sorter: (a, b) => a["9.00"] - b["9.00"],
      width: 75,
    },
    {
      title: "8.50",
      dataIndex: "8.5",
      sorter: (a, b) => a["8.50"] - b["8.50"],
      width: 75,
    },
    {
      title: "8.00",
      dataIndex: "8.0",
      sorter: (a, b) => a["8.00"] - b["8.00"],
      width: 75,
    },
    {
      title: "7.50",
      dataIndex: "7.5",
      sorter: (a, b) => a["7.50"] - b["7.50"],
      width: 75,
    },
    {
      title: "7.00",
      dataIndex: "7.0",
      sorter: (a, b) => a["7.00"] - b["7.00"],
      width: 75,
    },
    {
      title: "6.50",
      dataIndex: "6.5",
      sorter: (a, b) => a["6.50"] - b["6.50"],
      width: 75,
    },
    {
      title: "6.00",
      dataIndex: "6.0",
      sorter: (a, b) => a["6.00"] - b["6.00"],
      width: 75,
    },
    {
      title: "5.50",
      dataIndex: "5.5",
      sorter: (a, b) => a["5.50"] - b["5.50"],
      width: 75,
    },
    {
      title: "5.00",
      dataIndex: "5.0",
      sorter: (a, b) => a["5.00"] - b["5.00"],
      width: 75,
    },
    {
      title: "4.50",
      dataIndex: "4.5",
      sorter: (a, b) => a["4.50"] - b["4.50"],
      width: 75,
    },
    {
      title: "4.00",
      dataIndex: "4.0",
      sorter: (a, b) => a["4.00"] - b["4.00"],
      width: 75,
    },
    {
      title: "3.50",
      dataIndex: "3.5",
      sorter: (a, b) => a["3.50"] - b["3.50"],
      width: 75,
    },
    {
      title: "3.00",
      dataIndex: "3.0",
      sorter: (a, b) => a["3.00"] - b["3.00"],
      width: 75,
    },
    {
      title: "2.50",
      dataIndex: "2.5",
      sorter: (a, b) => a["2.50"] - b["2.50"],
      width: 75,
    },
    {
      title: "2.00",
      dataIndex: "2.0",
      sorter: (a, b) => a["2.00"] - b["2.00"],
      width: 75,
    },
    {
      title: "1.50",
      dataIndex: "1.5",
      sorter: (a, b) => a["1.50"] - b["1.50"],
      width: 75,
    },
    {
      title: "1.00",
      dataIndex: "1.0",
      sorter: (a, b) => a["1.00"] - b["1.00"],
      width: 75,
    },
  ];

  const onSearch = (values) => {
    const filters = [];
    Object.keys(values).map((key) => {
      const value = values[key];
      if (value !== undefined) {
        filters.push({ key: key, value: value });
      }
    });

    if (!filters.length) {
      return;
    }

    setLoading(true);
    Axios.get(
      getAjaxUrl() +
        `?action=mnt_get_population_report&filters=${JSON.stringify(values)}`
    )
      .then((res) => {
        const data = res.data.res;
        const groupedCards = {};

        data.forEach((card) => {
          const name = `${card.name.trim()}_${card.year.trim()}_${card.setName.trim()}_${card.subsetName.trim()}_${card.card_no}`;
          if (groupedCards[name] === undefined) {
            groupedCards[name] = {
              name: card.name,
              set: card.setName,
              year: card.year,
              subset: card.subsetName,
              company: card.company,
              card_no: card.card_no,
              "10.0F": 0,
              "10.0": 0,
              9.5: 0,
              "9.0": 0,
              8.5: 0,
              "8.0": 0,
              7.5: 0,
              "7.0": 0,
              6.5: 0,
              "6.0": 0,
              5.5: 0,
              "5.0": 0,
              4.5: 0,
              "4.0": 0,
              3.5: 0,
              "3.0": 0,
              2.5: 0,
              "2.0": 0,
              1.5: 0,
              "1.0": 0,
            };
          }
          let ratingIndex = card.flawless ? "10.0F" : parseFloat(card.rating).toFixed(1);

          groupedCards[name][ratingIndex]++;
        });

        const savedData = Object.keys(groupedCards).map(
          (objKey) => groupedCards[objKey]
        );
        console.debug(savedData);
        setCards(savedData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <div className={`mnt-population-report ${state.loading ? "loading" : ""}`}>
      {state.loading && <SpinLoader />}

      <h4>Population Report</h4>
      <SearchPopulation onSearch={onSearch} loading={loading} />
      <hr />
      <Table
        size="small"
        scroll={{ x: 1200, y: 500}}
        dataSource={cards}
        columns={headers}
      />
    </div>
  );
}

export default PopulationReport;
